import { useState, useEffect, useRef, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";

import exmark from "../../exmark.png";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";
import InputInteger from "../../helpers/InputInteger";
import InputDate from "../../helpers/InputDate";
import PostReview from "./PostReview";



function Received(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);



    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   

        numer_dokumentu:  props.mainView.readFilter('p_numer_dokumentu',''),   
        rodzaj:  props.mainView.readFilter('p_rodzaj','przychodzaca'),   
        data_od:  props.mainView.readFilter('p_data_od',''),   
        data_do:  props.mainView.readFilter('p_data_do',''),   
        numer_przesylki:  props.mainView.readFilter('numer_przesylki',''),   
       
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    
    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'firma przeniesiona do archiwum',
            filter: {  filed: "archiwalny", set: "1", typ: "combo"  },
        },
         {
            cls:'color_show4',
            title: 'fakturowanie aktualnie wstrzymane',
            filter: {  filed: "fakturowanie", set: "1", typ: "combo"  },
        },
    ]);


 



        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

            props.mainView.writeFilter('p_numer_dokumentu', '');
            props.mainView.writeFilter('p_rodzaj', 'przychodzaca');
            props.mainView.writeFilter('p_data_od', '');
            props.mainView.writeFilter('p_data_do', '');
            props.mainView.writeFilter('numer_przesylki', '');
           
           

            setFilterParam({
                  
                numer_dokumentu: '',                 
                rodzaj: 'przychodzaca',                 
                data_od: '',                 
                data_do: '',                 
                numer_przesylki: '',                 
             
                  
                
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {
        
        props.mainView.showProgress();       

        fetch( Config.url + '/rest_v1_post,post_headers', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }


    
    
    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');
            setView({...view, ["v"]:v, ["id"]:id });
    }



    
    const goDownload = (e) => {

         var id = e.target.getAttribute('atr-id');
         var title = "ksiazka";

         var fileName = title.replace(/[/]/g,"_") + ".pdf";

         var links = [
            {
                link: '/rest_v1_post,pdf',
                typ: 'pdf',
                fileName:  fileName,
                params: {
                    id: id
                },
            }
         ];

         if(Config.env == 'dev') console.log("goDownload", id, title);
         props.mainView.downloadDialog(links);
    }

  


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }

    



   const keyListener = (e) => {
                       var code = e.keyCode ? e.keyCode : e.which;    

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                                filterClear();
                        }else                            
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                                filterClear();
                        }else                                                                     
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                                setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                                setTab(null);
                        }else                                              
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                            props.keyListener(e);
                        }
   }



   useEffect( ()=>{

            if(Config.env == "dev") console.log("Received.js, listener on");
            window.onkeydown = keyListener; 

            return () => {   
                 if(Config.env == "dev") console.log("Received.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );








    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        setTab(null);       
    }



    if(tab == null)
    {
        setTab([]);
        getTab();       
        return <div>
            ...
        </div>
    }


    document.title = "Odebrane / Przychodzące";


    if(view.v == "edit")
    {
       return <PostReview  userData={props.userData} mainView={props.mainView} onBack={onBack}   keyListener={keyListener}   onSuccess={onSuccess}   id={view.id} detTyp='przychodzaca' />
    }



    if(view.v == "new")
    {
        return <PostReview  userData={props.userData} mainView={props.mainView} onBack={onBack}   keyListener={keyListener}   onSuccess={onSuccess}  id={-1} detTyp='przychodzaca'  />
    }
    

 
    var sortList = [                         
        {column: "data", name: "Data"  },
    ]

    var titleRaport = "Odebrane / Przychodzące";

    

    return  <div className="view_content">

            

                <h3 className="dash_header">Odebrane / Przychodzące</h3>

    
               <div className="table_filter">

                        <div className="filter_controll">   
                                <label>Numer dokumentu: </label>                             
                                <InputText   userData={props.userData} value={filterParam.numer_dokumentu}   valChange={valChangeListener} goNext={goNextNew} name="numer_dokumentu" placeholder={"Numer dokumentu: "} className="w200"  />
                        </div> 

                        <div className="filter_controll">   
                                <label>Numer przesyłki: </label>                             
                                <InputText   userData={props.userData} value={filterParam.numer_przesylki}   valChange={valChangeListener} goNext={goNextNew} name="numer_przesylki" placeholder={"Numer przesyłki: "} className="w200"  />
                        </div> 
                    
                    
                        <div className="filter_controll filter_merge">   
                                <label>Data (od dnia / do dnia): </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                        </div> 
 
                      

                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                              <div className="btn" onClick={changeView} v="new" id="-1"  > dodaj [+]</div>

                              &nbsp;&nbsp;
 

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />


                              &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />


                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>


               <div className="bg_center">


                        <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3> 
                      
                         
                        </div>


                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                                                                                                                                                               
                                                <td>Numer</td>                                                                                                                                                                              
                                                <td>Data</td>                                                                                                                                                                              
                                                <td>Operator</td>                                                                                                                                                                              
                                                <td className="td_right">Status</td>    
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";                                                          

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                                                                      
                                                                <td v="edit" id={row.id} onClick={changeView} className="gocenter">{row.numer_dokumentu}</td>
                                                                <td v="edit" id={row.id} onClick={changeView} className="gocenter">{row.data}</td>
                                                                <td v="edit" id={row.id} onClick={changeView} className="gocenter">{row.operator.nazwa}</td>
                                                                <td v="edit" id={row.id} onClick={changeView} className="gocenter">{row.status}</td>
                                                                                                                  
                                                                <MenuTable>
                                                                    <ul>                                                                        
                                                                        <li v="edit" id={row.id} onClick={changeView}>Zmień dane</li>
                                                                        <li   atr-id={row.id} onClick={goDownload}>Pobierz PDF</li>
                                                                    </ul>
                                                                </MenuTable>
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>

               </div>
 
              

                              
 

    </div>
}


export default Received;